import { useModal, ButtonColor } from '@ampol/design-system';

interface UpdateCardDetailsModalProps {
  onYesClick: () => void;
  onNoClick: () => void;
}

const useUpdateCardDetailsModal = (props: UpdateCardDetailsModalProps) => {
  const modal = useModal({
    color: ButtonColor.Blue,
    title: 'Update card details?',
    id: 'update-card-details-modal',
    variant: 'double',
    content: (
      <p>Do you wish to update the card details before they are replaced?</p>
    ),
    actions: [
      {
        label: 'Yes',
        onClick: () => props.onYesClick(),
      },
      {
        label: 'No',
        onClick: () => props.onNoClick(),
      },
    ],
  });

  return modal;
};

export default useUpdateCardDetailsModal;
